module.exports = __webpack_public_path__ + "img/features-img.95ffb5ab.gif";